import { useEffect } from "react";
import Footer from "../../components/layout/Footer";
import Navbar from "../../components/layout/Navbar";
import CTA from "./components/CTA";
import FAQ from "./components/FAQ";
import Hero from "./components/Hero";
import RouteGame from "./components/RouteGame";
import LogoStrip from "./components/LogoStrip";
import Methodology from "./components/Methodology";
import Pricing from "./components/Pricing";
import TechnicalDeepDive from "./components/TechnicalDeepDive";
import TrustBadges from "./components/TrustBadges";
import UseCases from "./components/UseCases";
import { useDocumentTitle } from "../../hooks/useDocumentTitle";

export default function LandingPage() {
  useDocumentTitle('', 'Find founders, executives, and decision makers at any company using AI-powered lead extraction.');

  useEffect(() => {
    document.documentElement.style.scrollBehavior = 'smooth';
    return () => { document.documentElement.style.scrollBehavior = ''; };
  }, []);

  return (
    <div className="bg-white font-sans overflow-x-hidden selection:bg-brand-500/20 selection:text-brand-900">
      <Navbar />
      <Hero />
      <RouteGame />
      <LogoStrip />
      <Methodology />
      {/* <TechnicalDeepDive /> */}
      <UseCases />
      <TrustBadges />
      <Pricing />
      <FAQ />
      <CTA />
      <Footer />
    </div>
  );
}
